var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useQuery } from '@tanstack/react-query';
import { getSession } from '@telus/koodo-shared-utils';
export var useGetSession = function (_a) {
    var authProxyUrl = _a.authProxyUrl, additionalHeaders = _a.additionalHeaders, useQueryOptions = _a.useQueryOptions;
    return useQuery(__assign({ queryKey: ['session'], queryFn: function () { return getSession({ authProxyUrl: authProxyUrl, additionalHeaders: additionalHeaders !== null && additionalHeaders !== void 0 ? additionalHeaders : {} }); } }, useQueryOptions));
};
